module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AEWGeQ/tc-custom/9781439676110.jpg?1705026066172",
      "alt": "This image is the cover for the book The San Francisco Doodler Murders, True Crime"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The San Francisco Doodler Murders, True Crime\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In 1974, one of San Francisco's most horrific unsolved serial murder cases began. ")])]), _c('br'), _c('p', [_vm._v("In less than two years, the man police called \"The Doodler\" took at least five lives, terrorized the LGBTQ community, and left three survivors forever changed. Initial reports claimed the murderer didn't approach his victims with the knife he used to kill them, but that the suspect shared skilled drawings--sketches of faces and animals--before leaving a string of gay men to bleed out on the sands of Ocean Beach. Police investigations and activist efforts to uncover the killer led to several suspects, but no definitive identification of the artist of death.")]), _c('br'), _c('p', [_vm._v("Author Kate Zaliznock shines a light on this riveting cold case.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Zaliznock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kate Zaliznock is a Bay Area-based writer and editor. Her past work has covered a wide range of topics, including music, history, science, pop culture and politics. She is also the founder of Open Color, an arts collective and magazine that features both emerging and established artists from around the globe. This is her first book on true crime.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0